import { render, staticRenderFns } from "./RiskModelEditor.vue?vue&type=template&id=f85304a6&scoped=true&"
import script from "./RiskModelEditor.vue?vue&type=script&lang=js&"
export * from "./RiskModelEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85304a6",
  null
  
)

export default component.exports